<template>
	<div>
		<message-component :message="response_msg" :messageType="msg_type"></message-component>
		<div class="mainTitle d-flex align-items-center justify-content-between px-0">
            <h2 class="my-3">{{$t('acclist_myAccounts')}}</h2> 
            <ul class="rightTabs-nifty d-flex align-items-center">
				<li :class="(accountTypeVar == '1')?'active' : ''"><a href="#" v-on:click.prevent="accountTypeVar = '1'">{{$t('acclist_liveAccount')}}</a></li>
				<li :class="(accountTypeVar == '0')?'active' : ''"><a href="#" v-on:click.prevent="accountTypeVar = '0'">{{$t('acclist_demoAccount')}}</a></li>
				<!-- <li :class="(accountTypeVar == '2')?'active' : ''"><a href="#" v-on:click.prevent="accountTypeVar = '2'">PAMM Investor Account</a></li> -->
			</ul>	
        </div> 
       			
		<div class="whiteBG pt-3 live-accountScroll mb-4">  
				<!--<div class="requestbtn d-flex align-items-center">
					<filter-component></filter-component>
				</div>-->
			<live-account v-if="accountTypeVar == '1'" :pageLoader1="pageLoader"></live-account>
			<demo-account v-if="accountTypeVar == '0'" :pageLoader1="pageLoader"></demo-account>
			<managed-account v-if="accountTypeVar == '2'" :pageLoader1="pageLoader"></managed-account>
		</div>
	</div>
</template>
<script>
	import live_account_list from './live_account_list'
	import demo_account_list from './demo_account_list'
	import managed_account_list from './managed_account_list.vue'
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'Trading-Account-List',
        mixins: [fxViewMixins],
        data() {
            return { 
            	//============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
            	accountTypeVar : '1',
            }
        },
        components: {
            liveAccount: live_account_list,
            demoAccount: demo_account_list,
            managedAccount: managed_account_list,
        },
        created(){
			//comes from create demo/live account page
			if(this.$route.params.accountTypeVar){
				this.accountTypeVar = this.$route.params.accountTypeVar
			}
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/account_list.vue